import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Customer, CustomerFilter, FilterCriteria } from '../../model/models';
import { CustomersService } from '../../services/customers/customers.service';
import { map, Observable, take, tap } from 'rxjs';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { FilterBuilderComponent } from './filter-builder/filter-builder.component';

@Component({
  selector: 'tt-filter',
  standalone: true,
  imports: [CommonModule, NzIconModule, FormsModule, NzButtonModule, NzSpinModule, NzTableModule, NzBreadCrumbModule, RouterLink, NzTypographyModule, NzCardModule, NzSkeletonModule, NzEmptyModule, FilterBuilderComponent],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent implements OnInit {
  @Input({ required: true }) customer!: Customer
  message = inject(NzMessageService)
  customersService = inject(CustomersService)
  searchInputValue: any
  isLoading = true
  isCRUD = true
  customerFilter = {} as CustomerFilter
  errorMsg = ""
  vehicleResults: any[] = [];
  vehiclesPreviewLoading = false
  vehiclesResult = {} as { meta: { count: number }, data: any[] }
  vehicleBrands = new Array
  resultLoading = true
  tracker = (i: number) => i;
  filterKeys = [
    "ordering_partner_group_id",
    "cardealer_id",
    "cardealer_sales_id",
    "cardealer_shipping_id",
    "cardealer_sales_partner_group_id",
    "cardealer_customer_name",
    "lessor_name",
    "cd_name_salesman",
    "cd_key_account_contract_no",
    "cardealer_customer_reference",
    "cardealer_partner_id",
    "current_shipping_partner_id",
    "cardealer_partner_group_id",
    "lessor_partner_group_id",
    "cardealer_major_customer_number",
    "admission_service_partner_id",
    "assembler_partner_id",
    "cd_system_field_1",
    "cd_system_field_2",
    "cd_system_field_3",
    "cd_system_field_4",
    "cd_system_field_5",
    "cd_system_field_6",
    "cd_system_field_7",
    "cd_system_field_8",
    "cd_system_field_9",
    "cd_system_field_10",
    "cd_system_field_11",
    "cd_system_field_12",
    "cd_system_field_13",
    "cd_system_field_14",
    "cd_system_field_15",
    "cd_system_field_16",
    "cd_system_field_17",
    "cd_system_field_18",
    "cd_system_field_19",
    "cd_system_field_20",
    "cd_system_field_21",
    "cd_system_field_22",
    "cd_system_field_23",
    "cd_system_field_24",
    "cd_system_field_25",
    "cd_system_field_26",
    "cd_system_field_27",
    "cd_system_field_28",
    "cd_system_field_29",
    "cd_system_field_30",
    "custom_fields_1",
    "lc_system_field_1",
    "lc_system_field_2",
    "lc_system_field_3",
    "lc_system_field_4",
    "lc_system_field_5",
    "lc_system_field_6",
    "lc_system_field_7",
    "lc_system_field_8",
    "lc_system_field_9",
    "lc_system_field_10",
    "order_type",
    "cardealer_sales_partner_id",
  ]
  ngOnInit(): void {
    this.customersService.getFilters(this.customer.pk).pipe(take(1))
      .subscribe(res => {
        this.customerFilter = res
        if (this.customerFilter.pk) {
          this.getVehiclesPreview();
        }
        if (!this.customerFilter.filter) {
          this.customerFilter.filter = new Array
        }
        this.isCRUD = false
      })
  }

  getVehiclesPreview() {
    this.vehiclesPreviewLoading = true
    this.customersService.getFilterPreview(this.customer.pk).subscribe(res => {
      if (res) {
        this.vehicleResults = res.data
      } else {
        this.vehicleResults = new Array
      }
      this.vehiclesPreviewLoading = false
    })
  }

  persistFilter = (filter: FilterCriteria): Observable<FilterCriteria> => {
    if (filter.length != 0) {
      return this.customersService.setFilter(this.customer.pk, { filter }).pipe(
        tap(res => {
          this.customerFilter = res
          this.message.success('Filter werden erfolgreich aktualisiert')
          this.getVehiclesPreview()
        }),
        map(res => res.filter)
      )
    }
    return this.customersService.deleteFilter(this.customer.pk).pipe(
      tap(() => {
        this.message.success('Filter werden gelöscht')
        this.getVehiclesPreview()
      }),
      map(() => filter)
    )
  }

  text2Slug(value: string): string {
    return value ? value.toLowerCase().replace(/ /g, '-') : ""
  }

}
